import React from 'react';
import { InstrumentId } from '../../../../../types/common';
import { useTabs } from '../../../../../hooks/useTabs';

interface Props {
  id: InstrumentId;
}

export const ActualItem: React.FC<Props> = ({ id }) => {
  const { idToTab } = useTabs();
  const tab = idToTab[id];

  if (!tab) {
    return <button>select in construction</button>;
  }

  return <tab.Select />;
};
